import * as metaStateUtils from '../../../../store/util/metaStateUtils';


/**
 * @param state {object} Domain state
 * @param orderSummary {object} Loaded order summary
 * @return {object} Updated domain state
 */
export default (state, orderSummary) => {

    const defaultOrder = metaStateUtils.withDefaultMetaState(orderSummary);
    state.orderSummaries[orderSummary.id] = metaStateUtils.setIsLoaded(defaultOrder);

    return state;
};
